import { IconButton } from "@mui/material";
import styled from "styled-components";

export const StyledIconButton = styled(IconButton)`
  padding: 0px 12px;
`;
